module.exports = __webpack_public_path__ + "img/video-scholarship@2x.0b62bd64.jpg";